var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showContainerDataset,
          expression: "showContainerDataset"
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "data-page-header", staticStyle: { height: "126px" } },
        [
          _c("div", { staticClass: "d-flex" }, [
            _c("img", {
              staticClass: "back-to-list-apps",
              attrs: { src: require("@/assets/icon/arrow-left.svg") },
              on: {
                click: function($event) {
                  _vm.$router.push("/joana")
                }
              }
            }),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(_vm.dataGroup ? _vm.dataGroup.name : ""))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("j-input", {
                staticClass: "text-search-data",
                attrs: { "error-required": false, placeholder: "Search" },
                model: {
                  value: _vm.filter_data,
                  callback: function($$v) {
                    _vm.filter_data = $$v
                  },
                  expression: "filter_data"
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass:
                  "fa fa-lg fa-plus font-weight-bold cursor-pointer m__t--10 m__l--10",
                attrs: { id: "addPopover" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.modeDetail
        ? _c("div", { staticClass: "data-page-header-full" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data-left-content" },
        _vm._l(_vm.datasetList, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "list-data-content",
              class: { active: _vm.dataset_id === item.id }
            },
            [
              _c(
                "div",
                {
                  staticClass: "item-data-manager",
                  on: {
                    click: function($event) {
                      _vm.switchForm(item)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "m__r--10",
                    attrs: {
                      src: require("@/assets/logo/dataset-icon-table.svg"),
                      height: "19"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info__list-data-content" }, [
                    _c("div", { staticClass: "title__list-data-content" }, [
                      _vm._v(_vm._s(item.name ? item.name : "No Name"))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "id__list-data-content" }, [
                      _vm._v(_vm._s(item.id))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "size__list-data-content" }, [
                    _vm._v(_vm._s(item.size))
                  ])
                ]
              )
            ]
          )
        })
      ),
      _vm._v(" "),
      _vm.modeDetail
        ? _c(
            "div",
            { staticClass: "data-right-update-content" },
            [
              _c("j-dataset-page-detail", {
                key: _vm.datasetId,
                attrs: {
                  "dataset-id": _vm.datasetId,
                  "find-record": _vm.findRecord
                },
                on: { reload: _vm.reloadAfterDelete }
              })
            ],
            1
          )
        : _c("div", { staticClass: "data-right-create-content" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/logo/dataset.svg"),
                height: "200"
              }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "m__t--20 m__b--20" }, [
              _vm._v("No Dataset Selected")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "btn__list-data-content",
                on: {
                  click: function($event) {
                    _vm.$refs.appTypeFormDataModal.show()
                  }
                }
              },
              [_vm._v("\n      Create Dataset\n    ")]
            )
          ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appTypeFormDataModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("CREATE DATASET")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-type-list-options" }, [
            _c(
              "div",
              {
                staticClass: "container-option",
                class: _vm.typeMode === "blank" ? "option-active" : "",
                on: {
                  click: function($event) {
                    _vm.typeMode = "blank"
                  }
                }
              },
              [
                _vm.typeMode === "blank"
                  ? _c("img", {
                      attrs: { src: require("@/assets/icon/blank-blue.png") }
                    })
                  : _c("img", {
                      attrs: { src: require("@/assets/icon/blank.png") }
                    }),
                _vm._v(" "),
                _c("span", { staticClass: "text-option" }, [
                  _vm._v("Create New Blank")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-option",
                class: _vm.typeMode === "code" ? "option-active" : ""
              },
              [
                _vm.typeMode === "code"
                  ? _c("img", {
                      attrs: { src: require("@/assets/icon/code-blue.png") }
                    })
                  : _c("img", {
                      attrs: { src: require("@/assets/icon/code.png") }
                    }),
                _vm._v(" "),
                _c("span", { staticClass: "text-option" }, [
                  _vm._v("Execute Code")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: {
                          click: function($event) {
                            _vm.$refs.appTypeFormDataModal.hide()
                          }
                        }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      { staticClass: "btn blue", on: { click: _vm.nextStep } },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appCodeFormDataModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("CREATE DATASET")
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "8" } }, [
                _c("label", [_vm._v(" JSON ")])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "p__r--1 m__t--3", attrs: { md: "3" } },
                [
                  _c("small", { staticClass: "pull-right" }, [
                    _vm._v("Dark Mode")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "p__l--1", attrs: { md: "1" } },
                [
                  _c("j-toggle", {
                    model: {
                      value: _vm.darkMode,
                      callback: function($$v) {
                        _vm.darkMode = $$v
                      },
                      expression: "darkMode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scroll-script" },
            [
              _c("prism-editor", {
                staticClass: "my-editor",
                class: { "dark-mode": _vm.darkMode },
                attrs: { highlight: _vm.highlighter, "line-numbers": true },
                model: {
                  value: _vm.jsonData,
                  callback: function($$v) {
                    _vm.jsonData = $$v
                  },
                  expression: "jsonData"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCodeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createCodeData }
                      },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appAddFormDataModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("CREATE DATASET")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.dataset_name.$error } },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.dataset_name.$error,
                  "max-length": 255,
                  placeholder:
                    "Only lowercase characters and underscore '_' are allowed, ex: name_form"
                },
                model: {
                  value: _vm.$v.dataset_name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.dataset_name, "$model", $$v)
                  },
                  expression: "$v.dataset_name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCreateForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createFormData }
                      },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appImportFormDataModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("IMPORT")
          ]),
          _vm._v(" "),
          _vm.dropboxImportShow
            ? _c("div", { staticClass: "dropbox-oos" }, [
                _c("input", {
                  staticClass: "input-file",
                  attrs: { type: "file", multiple: "" },
                  on: {
                    change: function($event) {
                      _vm.handleFileUpload($event.target.files)
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: require("@/assets/form-data/file-dropbox.png") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "label-dropbox" }, [
                  _vm._v("Drop your file here, or "),
                  _c("span", [_vm._v("browse")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "label-support-dropbox" }, [
                  _vm._v("Support : JSON")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray",
                        on: { click: _vm.closeImportForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-floating-data-manager",
          class: {
            "show-container-floating-data-manager": _vm.showProperties,
            "hide-container-floating-data-manager": !_vm.showProperties,
            "container-floating-data-manager-long": !_vm.is_sidebar_minimized
          }
        },
        [
          _c("div", { staticClass: "count-data-selected" }, [
            _vm._v(_vm._s(_vm.selected_rows.length))
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "btn-export-data" }, [
            _c("img", {
              attrs: { src: require("@/assets/icon/export-data-white.svg") }
            }),
            _vm._v(" Export\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-data-selected",
              on: { click: _vm.unselectAll }
            },
            [_vm._v("X")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "addPopoverRef",
          attrs: {
            show: _vm.addPopoverShow,
            target: "addPopover",
            placement: "bottom"
          },
          on: {
            "update:show": function($event) {
              _vm.addPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "add-data-manager",
              on: {
                click: function($event) {
                  _vm.$refs.appAddFormDataModal.show()
                  _vm.addPopoverShow = false
                }
              }
            },
            [
              _c("div", { staticClass: "w__10" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/form-data/new-blank-small.png")
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m__l--10" }, [
                _vm._v("Create New Blank")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "add-data-manager",
              staticStyle: { opacity: "0.3" }
            },
            [
              _c("div", { staticClass: "w__10" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/form-data/execute-code-small.png")
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m__l--10" }, [_vm._v("Execute Code")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "add-data-manager",
              staticStyle: { opacity: "0.3" }
            },
            [
              _c("div", { staticClass: "w__10" }, [
                _c("img", {
                  attrs: { src: require("@/assets/form-data/import-small.png") }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m__l--10" }, [_vm._v("Import")])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-data-selected" }, [
      _vm._v("Dataset "),
      _c("br"),
      _vm._v(" Selected")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0ae84be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0ae84be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/jDataset.vue
// module id = null
// module chunks = 